module.exports = __webpack_public_path__ + "img/cb.f77312f7.png";